import { ScreenSpaceEventType, } from "cesium";
import { ArbitraryLine, ConstructionState, } from "../../site/arbitrary-line/earthbrain-arbitrary-line";
import { getDefaultLineworkSettings } from "../../settings/earthbrain-site-settings";
import { PositionReference, checkPositionWrtToTileset, } from "../../utilities/local-utilities";
import { AddPointCommand } from "./arbitrary-line-command";
import { PointType } from "../../site/arbitrary-line/types";
export class ArbitraryLineHandler {
    _site;
    _arbitraryLineUnderConstruction;
    _cesiumViewer;
    _preview;
    _viewer;
    _commandManager;
    _cesiumPicker;
    _handler;
    _callback;
    _finishArbitraryLineConstructionHandler;
    _lineProfileView;
    constructor(args, cesiumViewer, lineProfileView) {
        this._site = args.site;
        this._viewer = args.viewer;
        this._preview = args.preview;
        this._commandManager = args.commandManger;
        this._cesiumPicker = args.cesiumPicker;
        this._handler = args.handler;
        this._cesiumViewer = cesiumViewer;
        this._lineProfileView = lineProfileView;
    }
    _mouseMoveDebounce = undefined;
    _debounceHandlerForSphereMovement(movement) {
        if (this._mouseMoveDebounce) {
            clearTimeout(this._mouseMoveDebounce);
            this._mouseMoveDebounce = undefined;
        }
        this._mouseMoveDebounce = setTimeout(() => {
            this._functionForPreviewSphereMovement(this._arbitraryLineUnderConstruction, movement);
            this._mouseMoveDebounce = undefined;
        }, 100);
    }
    _functionForPreviewSphereMovement(arbitraryLine, movement) {
        const cartesian = this._cesiumPicker.getPointOnMousePos(movement.endPosition);
        if (cartesian) {
            this._preview.setSpherePosition(cartesian);
            // add point to the road id the ditance between it and last point is less than 10 KM
            if (arbitraryLine &&
                arbitraryLine.controlPointLength > 0 &&
                arbitraryLine.getDistanceFromLastPoint(cartesian) < 10) {
                this._preview.setLineVisibility(true);
                this._preview.setLinePosition([
                    arbitraryLine.lastControlPoint.pointInfo.position,
                    cartesian,
                ]);
            }
            else {
                this._preview.setLinePosition([]);
            }
            this._viewer.scene.requestRender();
        }
    }
    addPointOnLeftClick(associatedTerrain, { position: mousePos }) {
        const previewPos = this._cesiumPicker.getPointOnMousePos(mousePos);
        if (previewPos) {
            this._site.convertPointsToLocalSpace([previewPos]).then((arr) => {
                const localPos = arr[0];
                const positionRef = checkPositionWrtToTileset(localPos, associatedTerrain);
                const pickedInfo = positionRef !== PositionReference.OUTSIDE
                    ? this._cesiumPicker.getPickablePickedInfo(mousePos)
                    : undefined;
                // Do not process further
                if (positionRef === PositionReference.OUTSIDE) {
                    this.raiseEventInvalidCtrlPtForRoad(this._arbitraryLineUnderConstruction.id);
                    return;
                }
                if (!localPos) {
                    console.error("Cound not find the Point");
                    return;
                }
                //need to convert local point to WGS84 point as preview pos needs to be updated when point is clicked on any entity.
                this._site.convertPointsToWGS84([localPos]).then((arr) => {
                    const wgs84point = arr[0];
                    if (this._arbitraryLineUnderConstruction.getDistanceFromLastPoint(previewPos) < 10) {
                        this._commandManager.action(new AddPointCommand(this._arbitraryLineUnderConstruction, {
                            position: wgs84point,
                            info: pickedInfo,
                            localPosition: localPos,
                        }, () => {
                            this._preview.setLinePosition([]);
                        }), this._cesiumViewer);
                        this._preview.setLineVisibility(true);
                        this._preview.setLinePosition([]);
                    }
                });
                this._callback.onProgress &&
                    this._callback.onProgress(this._arbitraryLineUnderConstruction.id, 0);
            });
        }
    }
    startArbitraryLineConstruction(callback, associatedTerrain) {
        this._callback = callback;
        this._arbitraryLineUnderConstruction = new ArbitraryLine(getDefaultLineworkSettings(), this._viewer, associatedTerrain);
        this._arbitraryLineUnderConstruction.constructionState =
            ConstructionState.UNDER_CONSTRUCTION;
        this._preview.setLineVisibility(true);
        this._preview.setSphereVisibility(true);
        this._handler.setInputAction(this._debounceHandlerForSphereMovement.bind(this), ScreenSpaceEventType.MOUSE_MOVE);
        this._handler.setInputAction(this.addPointOnLeftClick.bind(this, associatedTerrain), ScreenSpaceEventType.LEFT_CLICK);
        this._finishArbitraryLineConstructionHandler =
            this._finishRoadConstruction.bind(this);
        document.addEventListener("keydown", this._finishArbitraryLineConstructionHandler);
    }
    _finishRoadConstruction(event) {
        switch (event.key) {
            case "Esc":
            case "Escape":
                this.cancel();
                break;
            case "Enter":
                this.finish();
                break;
            default:
        }
    }
    finish() {
        this._commandManager.clear();
        if (this._arbitraryLineUnderConstruction.controlPointLength > 1) {
            this._arbitraryLineUnderConstruction.lastControlPoint.pointType =
                PointType.END_POINT;
            this._arbitraryLineUnderConstruction.constructionState =
                ConstructionState.READY;
            this._site.addArbitraryLine(this._arbitraryLineUnderConstruction);
            this._arbitraryLineUnderConstruction.createLabels();
            this._preview.setLineVisibility(false);
            this._preview.setSphereVisibility(false);
            this._handler.removeInputAction(ScreenSpaceEventType.LEFT_CLICK);
            this._handler.removeInputAction(ScreenSpaceEventType.MOUSE_MOVE);
            this._finishArbitraryLineConstructionHandler &&
                document.removeEventListener("keydown", this._finishArbitraryLineConstructionHandler);
            this._callback.onFinish &&
                this._callback.onFinish(this._arbitraryLineUnderConstruction.id);
            this._arbitraryLineUnderConstruction = undefined;
        }
        else {
            console.warn("Arbitrary Line needs atleast 2 points.");
            this.cancel();
        }
    }
    cancel(id) {
        if (id) {
            this._site.deleteArbitraryLine(id);
        }
        if (this._arbitraryLineUnderConstruction) {
            this._arbitraryLineUnderConstruction.dispose();
        }
        this._arbitraryLineUnderConstruction = undefined;
        this._preview.setSphereVisibility(false);
        this._preview.setLineVisibility(false);
        this._handler.removeInputAction(ScreenSpaceEventType.LEFT_CLICK);
        this._handler.removeInputAction(ScreenSpaceEventType.MOUSE_MOVE);
        this._finishArbitraryLineConstructionHandler &&
            document.removeEventListener("keydown", this._finishArbitraryLineConstructionHandler);
        this._callback?.onCancel && this._callback.onCancel();
        this._viewer.scene.requestRender();
    }
    raiseEventInvalidCtrlPtForRoad(lineID) {
        const event = new CustomEvent("invalidControlPointForLine", {
            detail: { lineID, type: 9 },
        });
        window.dispatchEvent(event);
        this._callback.onError && this._callback.onError();
    }
    toggleVisibility(arbitraryLine, show) {
        arbitraryLine.updateVisibility(show);
    }
    getArbitraryLineJSON(arbitraryLine) {
        return arbitraryLine.toJSON();
    }
    checkArbitraryLineUnderCreation() {
        return (this._arbitraryLineUnderConstruction &&
            this._arbitraryLineUnderConstruction.constructionState ===
                ConstructionState.UNDER_CONSTRUCTION);
    }
}
//# sourceMappingURL=arbitraryLine-handler.js.map